<div class="flex-row flex-wrap">
  <ng-container *ngIf="addressTypes$ | async as options">
    <!-- need addressTypes at the top before checking Show address type: inorder to get the list of addresstypes -->
    <ng-container *ngIf="config.showAddressType">
      <cf2-select-field-top
        [ctrl]="getFc('code')"
        [label]="labels.code"
        [required]="required.code"
        [disabled]="disabled.code"
        [options]="options"
        [disabled]="isReadOnly"
      ></cf2-select-field-top>
    </ng-container>
  </ng-container>

  <mat-checkbox
    *ngIf="config.showPrimaryField"
    [formControl]="getFc('primary')"
    [required]="required.primary"
    [disableControl]="getFc('primary').value"
    (change)="primaryAddressChanged($event)"
    [disabled]="isReadOnly"
  >
    {{ getFc('primary').value ? 'Primary' : labels.primary }}
  </mat-checkbox>
</div>
<div class="flex-row flex-wrap">
  <cf2-input-field-top
    [ctrl]="getFc('unit')"
    [label]="labels.unit"
    [required]="required.unit"
    [small]="false"
    [disabled]="isReadOnly"
  >
  </cf2-input-field-top>

  <cf2-input-field-top
    [ngStyle]="{ flex: '0.9' }"
    [ctrl]="getFc('addressLine1')"
    [label]="labels.addressLine1"
    [required]="required.addressLine1"
    [fullWidth]="true"
    [small]="true"
    [disabled]="isReadOnly"
  >
  </cf2-input-field-top>

  <cf2-input-field-top
    [ngStyle]="{ flex: '0.9' }"
    [ctrl]="getFc('addressLine2')"
    [label]="labels.addressLine2"
    [required]="required.addressLine2"
    [fullWidth]="true"
    [small]="true"
    [disabled]="isReadOnly"
  >
  </cf2-input-field-top>

  <cf2-input-field-top
    [ctrl]="getFc('city')"
    [label]="labels.city"
    [required]="required.city"
    [disabled]="isReadOnly"
    [small]="true"
  >
  </cf2-input-field-top>

  <ng-container *ngIf="provinceTypes$ | async as options">
    <cf2-select-field-top
      [ctrl]="getFc('provinceCode')"
      [label]="labels.provinceCode"
      [required]="required.provinceCode"
      [disabled]="disabled.provinceCode"
      [options]="options"
      [small]="true"
      [disabled]="isReadOnly"
    ></cf2-select-field-top>
  </ng-container>

  <cf2-postal-field-top
    [ctrl]="getFc('postalCode')"
    [label]="labels.postalCode"
    [required]="required.postalCode"
    [small]="false"
    [disabled]="isReadOnly"
  >
  </cf2-postal-field-top>
</div>
<div class="flex-row flex-wrap">
  <cf2-date-field-top
    *ngIf="config.showEffectiveDate"
    [ctrl]="getFc('addressEffectiveDate')"
    [label]="labels.addressEffectiveDate"
    [required]="required.addressEffectiveDate"
    [disabled]="disabled.addressEffectiveDate"
    [minDate]="minDate"
    [maxDate]="maxDate"
    [disabled]="isReadOnly"
  ></cf2-date-field-top>

  <cf2-date-field-top
    *ngIf="config.showExpiryDate"
    [ctrl]="getFc('addressExpiryDate')"
    [label]="labels.addressExpiryDate"
    [required]="required.addressExpiryDate"
    [disabled]="disabled.addressExpiryDate"
    [minDate]="minDate"
    [maxDate]="maxDate"
    [disabled]="isReadOnly"
  ></cf2-date-field-top>
</div>